export enum InformationType {
  DIRECT = 'DIRECT',
  PINNED = 'PINNED',
  HISTORY = 'HISTORY',
  ARCHIVED = 'ARCHIVED'
}
